module.exports = __webpack_public_path__ + "static/media/typography_1024x768.96c63a5a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/assets/typography_1024x768.jpg
 ** module id = 162
 ** module chunks = 0
 **/